(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-customer-care"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clickTidioLauncher = () => {
      const launcher = document.getElementById('button-body');

      if (!launcher) {
        return false;
      }

      launcher.click();
      return true;
    };

    const openTidioChat = () => {
      if (clickTidioLauncher()) {
        return true;
      }

      if (!window.tidioChatApi) {
        return false;
      }

      if (typeof window.tidioChatApi.show === 'function') {
        window.tidioChatApi.show();
      }

      if (typeof window.tidioChatApi.open === 'function') {
        window.tidioChatApi.open();
        return true;
      }

      return false;
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-tidio-open]');

      if (!trigger) {
        return;
      }

      event.preventDefault();

      if (openTidioChat()) {
        return;
      }

      const onReady = () => {
        openTidioChat();
        document.removeEventListener('tidioChat-ready', onReady);
      };

      document.addEventListener('tidioChat-ready', onReady, { once: true });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
